import { render } from "./cwzbnewZui.vue?vue&type=template&id=cbd133fc&scoped=true&ts=true"
import script from "./cwzbnewZui.vue?vue&type=script&lang=ts"
export * from "./cwzbnewZui.vue?vue&type=script&lang=ts"

import "./cwzbnewZui.vue?vue&type=style&index=0&id=cbd133fc&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbd133fc"]])

export default __exports__